import { makeStyles } from '@material-ui/core/styles';
import { SEARCH_TABS } from 'src/constants/SearchTabs';

const useStyles = (
  selected:boolean,
  first?: boolean,
  disabled?: boolean,
) => makeStyles((theme) => ({
  datagridSearchTab: {
    height: '30px',
    lineHeight: '30px',
    verticalAlign: 'middle',
    padding: theme.spacing(0, 2),
    borderRight: '1px solid #eee',
    borderTop: '1px solid #eee',
    borderLeft: first ? '1px solid #eee' : '',
    opacity: disabled ? 0.5 : 1,
    cursor: disabled ? 'not-allowed' : 'pointer',
    '&:hover': disabled ? {} : {
      backgroundColor: theme.palette.primary.light,
      color: '#FFF',
      cursor: 'pointer',
      borderRight: '1px solid #FFF',
    },
    backgroundColor: selected ? theme.palette.primary.main : '',
    color: selected ? '#fff' : theme.palette.text.primary,
  },
}));
//
interface Props {
  text: string;
  first?: boolean;
  id?:string;
  setSelected: (selected: SEARCH_TABS) => void;
  selected: boolean;
  tab: SEARCH_TABS;
  disabled?: boolean;
}

const DatagridSearchTab = (props: Props) => {
  const {
    text, first, id, selected, setSelected, tab, disabled = false,
  } = props;

  const classes = useStyles(selected, first, disabled)();

  return (
    <div
      id={id}
      className={classes.datagridSearchTab}
      onClick={() => { if (!disabled) setSelected(tab); }}>
      {text}
    </div>
  );
};

export default DatagridSearchTab;
